// DevStateInspector — dev-only panel som visar workflow-statens
// nyckeltal live (#17 i PRE_RELEASE_REVIEW_100). Snabbar upp
// bug-repro: "hur många blocks/sheets, vilket är selected, är staten
// dirty?" utan console.log-arkeologi.
//
// Production-bygget renderar ALDRIG denna (import.meta.env.DEV-gate i
// mount-komponenten nedan + tree-shake av hela filen via dynamisk
// import). Toggle: Ctrl/Cmd+Shift+D.

import { useEffect, useState } from 'react';
import { useWorkflow } from '@/contexts/WorkflowContext';
import { useSelectionMode } from '@/contexts/SelectionModeContext';

function InspectorPanel() {
  const {
    blocks, connectors, groups,
    sheets, activeSheetIndex,
    selectedBlockId, workflowName,
    canUndo, canRedo,
    currentLayerGroupId,
  } = useWorkflow();
  const { selectedGroupId, selectedConnectorId, connectMode, groupMode } = useSelectionMode();

  const rows: Array<[string, string | number | boolean | null]> = [
    ['workflowName', workflowName],
    ['sheets', sheets.length],
    ['activeSheetIndex', activeSheetIndex],
    ['blocks', blocks.length],
    ['connectors', connectors.length],
    ['groups', groups.length],
    ['selectedBlockId', selectedBlockId],
    ['selectedGroupId', selectedGroupId],
    ['selectedConnectorId', selectedConnectorId],
    ['currentLayerGroupId', currentLayerGroupId],
    ['connectMode', connectMode],
    ['groupMode', groupMode],
    ['canUndo', canUndo],
    ['canRedo', canRedo],
  ];

  return (
    <div
      className="fixed bottom-4 right-4 z-[100] w-72 rounded-lg border bg-popover/95 p-3 font-mono text-[11px] shadow-xl backdrop-blur"
      data-testid="dev-state-inspector"
    >
      <div className="mb-2 flex items-center justify-between text-xs font-semibold">
        <span>Dev state inspector</span>
        <kbd className="rounded border bg-muted px-1 text-[9px]">⌘⇧D</kbd>
      </div>
      <table className="w-full">
        <tbody>
          {rows.map(([key, value]) => (
            <tr key={key} className="border-t border-border/40">
              <td className="py-0.5 pr-2 text-muted-foreground">{key}</td>
              <td className="py-0.5 text-right break-all">
                {value === null ? 'null' : String(value)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/**
 * Mount-komponent: lyssnar på Ctrl/Cmd+Shift+D och togglar panelen.
 * Renderar null i production-byggen.
 */
export function DevStateInspector() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!import.meta.env.DEV) return;
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key.toLowerCase() === 'd') {
        e.preventDefault();
        setOpen((o) => !o);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  if (!import.meta.env.DEV || !open) return null;
  return <InspectorPanel />;
}
